import { postForm, request } from './client'
import { USE_MOCK } from './config'
import { mockVolumeApi, mockPublicOptionApi, mockReportApi, mockSystemApi } from './mock'

export const volumeApi = USE_MOCK ? mockVolumeApi : {
  getProject: (projectid: string, time_period: number) =>
    postForm('/volume/getproject', { projectid, time_period }),

  getProjectName: (projectid: string, groupId: string) =>
    postForm('/volume/projectname', { projectid, groupId }),
}

export const publicOptionApi = USE_MOCK ? mockPublicOptionApi : {
  list: (pagenum: number = 1, searchkeyword: string = '') =>
    postForm('/publicoption/list', { pagenum, searchkeyword }),

  getById: (id: number) =>
    postForm('/publicoption/getdatabyid', { id }),

  update: (params: {
    id: number
    eventname: string
    eventkeywords: string
    eventstarttime: string
    eventendtime: string
    eventstopwords: string
  }) => postForm('/publicoption/updatedatabyid', params),

  create: (params: {
    eventname: string
    eventkeywords: string
    eventstarttime: string
    eventendtime: string
    eventstopwords: string
  }) => postForm('/publicoption/addpublicoptiondata', params),

  delete: (Ids: string) =>
    postForm('/publicoption/deletepublicoptioninfo', { Ids }),

  reportList: (pagenum: number = 1, searchkeyword: string = '') =>
    postForm('/publicoption/publicoptionreportlist', { pagenum, searchkeyword }),

  loadInformation: (params: Record<string, any>) =>
    request('/publicoption/loadInformation', { method: 'POST', data: params }),

  backAnalysis: () =>
    request('/publicoption/backanalysis', { method: 'GET' }),
  eventContext: () =>
    request('/publicoption/eventContext', { method: 'GET' }),
  eventTrace: () =>
    request('/publicoption/eventTrace', { method: 'GET' }),
  hotAnalysis: () =>
    request('/publicoption/hotAnalysis', { method: 'GET' }),
  netizensAnalysis: () =>
    request('/publicoption/netizensAnalysis', { method: 'GET' }),
  statistics: () =>
    request('/publicoption/statistics', { method: 'GET' }),
  propagationAnalysis: () =>
    request('/publicoption/propagationAnalysis', { method: 'GET' }),
  thematicAnalysis: () =>
    request('/publicoption/thematicAnalysis', { method: 'GET' }),
  unscrambleContent: () =>
    request('/publicoption/unscrambleContent', { method: 'GET' }),
}

export const reportApi = USE_MOCK ? mockReportApi : {
  list: (params: {
    pageNum: number
    reportType?: number
    nameSearch?: string
    projectId?: string
  }) => postForm('/report/listReportCustom', params),

  detail: (reportId: string) =>
    postForm('/report/reportDetail', { reportId }),

  batchDelete: (reportIds: string) =>
    postForm('/report/batchUpdateReportCustom', { reportIds }),

  batchUpdateStatus: (reportIds: string) =>
    postForm('/report/batchUpdateReportCustomStatus', { reportIds }),
}

export const systemApi = USE_MOCK ? mockSystemApi : {
  listWarning: (page: number, groupId?: string) =>
    postForm('/system/listWarning', { page, groupId }),

  updateWarningStatus: (warning_status: number, project_id: string) =>
    postForm('/system/updateWarningStatusById', { warning_status, project_id }),

  getWords: (project_id: string) =>
    postForm('/system/getwords', { project_id }),

  updateWarning: (params: Record<string, any>) =>
    postForm('/system/updateWarning', params),

  getWarningArticle: (pageNum: number, openFlag?: number, project_id?: string) =>
    postForm('/system/getWarningArticle', { pageNum, openFlag, project_id }),

  getOpinionCondition: (projectId: string) =>
    postForm('/system/getOpinionConditionByProjectId', { projectId }),

  updateOpinionCondition: (params: Record<string, any>) =>
    request('/system/updateOpinionCondition', {
      method: 'POST',
      data: JSON.stringify(params),
      headers: { 'Content-Type': 'application/json' },
    }),

  listSolutionGroups: () =>
    postForm('/system/listSolutionGroupByUserId', {}),

  listProjectsByGroup: (groupId: string) =>
    postForm('/system/listProjectByGroupId', { groupId }),

  getSystemTitle: () =>
    postForm('/system/getSystemTitle', {}),
}
